import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CloudDownload from '@material-ui/icons/CloudDownload';
import CloudUpload from '@material-ui/icons/CloudUpload';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { uploadFile, downloadModel } from '../../store/actions/importEmployees';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import ConfirmDialog from '../../components/ConfirmDialog/ConfirmDialog';
import ImportConfirmationDialog from './ImportSucess';

const styles = theme => ({
  card: theme.mixins.gutters({
    padding: '16px',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    height: 'auto',
    minHeight: '260px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  }),
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  button: {
    margin: 'auto',
    padding: '15px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  icon: {
    marginRight: '5px',
  },
});

class ImportEmployee extends Component {
  state = {
    openDialog: false,
    dialogText: '',
  }

  render() {
    const {
      classes, loading, onDownloadModel, onUploadFile,
    } = this.props;
    return (
      <React.Fragment>
        <ContentHeader
          title="Importar Funcionários"
          subtitle="Baixe a planilha para poder importar vários funcionários de uma única vez"
        />

        <Grid container spacing={2} alignItems="center" justify="space-between">
          <Grid item xs={12} sm={6} >
            <Paper elevation={2} className={classes.card}>
              <Typography
                variant="text"
                component="h3"
                color="textSecondary"
                align="center"
                gutterBottom
              >
                Baixe o Modelo
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                align="justify"
                gutterBottom
              >
                Esse arquivo de modelo é uma planilha onde você pode preencher com os dados
                de todos os funcionários.
              </Typography>

              <div>
                <Button
                  className={classes.button}
                  variant="contained"
                  color="primary"
                  onClick={onDownloadModel}
                  autoFocus
                >
                  <CloudDownload className={classes.icon} /> Baixar Modelo
                </Button>
              </div>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6} >
            <Paper elevation={2} className={classes.card}>
              <Typography
                variant="text"
                component="h3"
                color="textSecondary"
                align="center"
                gutterBottom
              >
                Importe os Funcionários
              </Typography>

              <Typography
                variant="body2"
                color="textSecondary"
                align="justify"
                gutterBottom
              >
                Depois de preencher o modelo, você pode importá-lo para cadastrar todos os funcionários.
              </Typography>

              <label htmlFor="contained-button-file">
                <Button
                  variant="contained"
                  component="span"
                  className={classes.button}
                  color="primary"
                  disabled={loading}
                >
                  {
                    loading ? (
                      <CircularProgress size={20} color="primary" />
                    ) : <React.Fragment>
                      <input
                        className={classes.input}
                        id="contained-button-file"
                        multiple
                        type="file"
                        accept=".xlsx,.ods"
                        style={{ display: 'none' }}
                        onChange={(file) => {
                          if (file && file.target.files[0]) {
                            onUploadFile(file.target.files[0])
                              .then(response => this.setState({ openDialog: true, dialogText: response }));
                            // .catch(error => this.setState({ openDialog: true, dialogText: error }));
                          }
                        }}
                      />

                      <CloudUpload className={classes.icon} />
                      Importar Planilha
                    </React.Fragment>
                  }
                </Button>
              </label>
            </Paper>
          </Grid>
        </Grid>

        <Typography color="textSecondary">
          * Os campos marcados com (*) são obrigatórios.
        </Typography>
        <Typography color="textSecondary" >
          * Os dados são de exemplo, então você deve apagá-los e substituir pelos seus próprios dados.
        </Typography>
        <Typography color="textSecondary" >
          * Observe o formato do campo ADMISSÃO que segue o padrão de data dd/MM/YYYY.
        </Typography>
        <Typography color="textSecondary" >
          * Não inserir linhas em branco entre os dados da planilha, não mudar a ordem das colunas da planilha.
        </Typography>

        {/* <ConfirmDialog
          open={this.state.openDialog}
          title="Funcionários importados com sucesso"
          onClose={() => this.setState({ openDialog: false })}
          content={this.state.dialogText}
          actions={
            [
              {
                title: 'Configurar individualmente',
                goTo: '/funcionarios',
              },
              {
                title: 'Configurar simultaneamente',
                goTo: '/aplicar-restricoes',
              },
            ]
          }
        /> */}
        <ImportConfirmationDialog
          open={this.state.openDialog}
          onClose={() => this.setState({ openDialog: false })}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
});

const mapDispatchToProps = dispatch => ({
  onDownloadModel: () => dispatch(downloadModel()),
  onUploadFile: file => dispatch(uploadFile(file)),
});

ImportEmployee.propTypes = {
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ImportEmployee));
